import { render, staticRenderFns } from "./CoefficientOfTerritorialZonesList.vue?vue&type=template&id=4087ebc6&scoped=true&"
import script from "./CoefficientOfTerritorialZonesList.vue?vue&type=script&lang=js&"
export * from "./CoefficientOfTerritorialZonesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4087ebc6",
  null
  
)

export default component.exports